module.exports = __webpack_public_path__ + "static/media/checked.ee136e1c.svg";